import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import FavoriteCardDesignLabPage from "@/components/pages/FavoriteCardDesignLabPage";
import type { FavoriteItem } from "@/components/pages/FavoritesPage";

export function CardDesignLab() {
  const [items, setItems] = useState<FavoriteItem[]>([]);

  useEffect(() => {
    api
      .get<{ items: FavoriteItem[] }>("/api/favorites")
      .then((r) => setItems(r.items))
      .catch(() => setItems([]));
  }, []);

  return <FavoriteCardDesignLabPage items={items} />;
}
